/**
 * boolean-pill.component.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Component, Input } from "@angular/core";

@Component({
    selector: "boolean",
    template: `
<span class="badge" [class.success]="value">
    {{value ? trueString : falseString}}
</span>
`,
  styles: [`span {font-size: 1em;}`]
})
export class BooleanPillComponent
{
    @Input()
    public value : boolean = false;

    @Input()
    public trueString : string = "enabled";

    @Input()
    public falseString : string = "disabled";
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/support/controls/boolean-pill.component.ts